import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router";

const NavContext = createContext();

export const NavProvider = ({ children }) => {
  const location = useLocation();

  const navItems = [
    { url: "/client/dashboard", name: "Dashboard" },
    {
      url: [
        "/client/payments",
        "/client/payments/add",
        "/client/payments/detail/:id",
        "/sales_user/payments",
        "/sales_user/payments/add",
        "/sales_user/payments/detail/:id",
      ],
      name: "Payments",
    },
    { url: ["/client/payouts", "/client/payouts/:id"], name: "Payouts" },
    {
      url: [
        "/client/accounts",
        "/client/accounts/:id",
        "/client/accounts/:id/edit-setting",
        "/client/creditMemo/:id",
      ],
      name: "Accounts",
    },
    {
      url: [
        "/client/invoices",
        "/client/add/invoices",
        "/client/invoices/:id",
        "/client/recurring-approvals",
      ],
      name: "Invoices",
    },
    { url: ["/client/tasks", "/client/tasks/:id"], name: "Tasks" },
    { url: ["/client/reports", "/client/reports/:id"], name: "Reports" },
    { url: "/client/history", name: "History" },
    { url: "/client/help", name: "Help" },
    {
      url: [
        "/client/change-account",
        "/client/settings",
        "/client/team",
        "/welcome-screen",
      ],
      name: "Company Settings",
    },
    {
      url: "/client/elavon",
      name: "Elavon",
    },
  ];

  const getNavName = () => {
    const currentPath = location.pathname;

    // Ensure any URL starting with "/welcome-screen" returns "Company Settings"
    if (currentPath.startsWith("/welcome-screen")) {
      return "Company Settings";
    }

    return (
      navItems.find((item) => {
        const urls = Array.isArray(item.url) ? item.url : [item.url];

        return urls.some((url) => {
          // Convert dynamic segments (e.g., "/client/invoices/:id") to a regex pattern
          const regex = new RegExp(`^${url.replace(/:\w+/g, "[^/]+")}$`);
          return regex.test(currentPath);
        });
      })?.name || "Dashboard" // Default to "Dashboard" if no match is found
    );
  };

  const [selectedNavItem, setSelectedNavItem] = useState(getNavName());

  useEffect(() => {
    setSelectedNavItem(getNavName());
  }, [location.pathname]);

  return (
    <NavContext.Provider value={{ selectedNavItem, setSelectedNavItem }}>
      {children}
    </NavContext.Provider>
  );
};

export const useNavContext = () => useContext(NavContext);
